module.exports = __webpack_public_path__ + "static/step6-3da515e9d399329d24f1f1387576d736.png";